<template>
<div>
    <v-progress-linear indeterminate color="primary" v-if="is_loading"></v-progress-linear>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Create Vendor</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <p class='err'>{{ error }}</p>
                                <v-form
                                 id="createvendor" 
                                 @submit.prevent="validateBeforeSubmit('createvendor')"
                                 data-vv-scope="createvendor" 
                                 ref="createvendor" 
                                 v-model="valid">
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                            <!-- <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                <v-text-field 
                                                    name="Type" 
                                                    v-model="vendor_object.type" 
                                                    label="Type" 
                                                    item-text="Type" 
                                                    item-value="type" 
                                                    :disabled=true 
                                                    :error-messages="errors.collect('createvendor.Type')">
                                                </v-text-field>
                                                </v-flex>
                                            </v-layout> -->
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                   <v-text-field 
                                                    name="Vendor Name" 
                                                    label="Vendor Name" 
                                                    id="Vendor Name" 
                                                    v-model="vendor_object.name"
                                                    v-validate="'required'" 
                                                    autocomplete="off"
                                                    :error-messages="errors.collect('createvendor.Vendor Name')">
                                                        <template v-slot:label>
                                                            Vendor Name <span style="color:red"> * </span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-text-field 
                                                    name="Mobile" 
                                                    label="Mobile" 
                                                    id="Mobile" 
                                                    v-validate="'required|numeric|min:10|max:10'" 
                                                    v-model="vendor_object.mobile"
                                                    autocomplete="off"
                                                    :error-messages="errors.collect('createvendor.Mobile')">
                                                        <template v-slot:label>
                                                            Mobile <span style="color:red"> * </span>
                                                        </template>
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md5>
                                                    <v-text-field 
                                                    name="Email" 
                                                    label="Email" 
                                                    id="email" 
                                                    :disabled="email_disable" 
                                                    v-model="vendor_object.email" 
                                                    :error-messages="errors.collect('createvendor.Email')">
                                                    </v-text-field>
                                                </v-flex>
                                               
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :disabled="!valid" :loading="loading" type="submit">Register</v-btn>
                                        <v-btn text small to="/registrations">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
       
      
    },
    methods: {
         validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        createvendor: function () {
            this.loading = true;
            let new_vendor = Object.assign({}, this.vendor_object);
            axios.post(`${process.env.VUE_APP_API_URL}/api/vendors`, new_vendor).then((response) => {
                if (response.data.status == 1) {
                    this.$router.push({
                        name: 'vendors',
                    });
                    this.loading = true;
                }
                if (response.data.status == 2) {
                    this.error = response.data.message;
                    this.loading = false;
                }
                if (response.data.status == 0) {
                    this.error = "Error Occured";
                    this.loading = false;
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {

            });
        },
       
  
    },
    data: () => {
        return {
            role: '',
            is_loading: false,
            error: '',
           
            vendor_details: '',
            email_disable: false,
            mobile_disable: false,
            vendor_object: {
                name: '',
                mobile: '',
                email: '',
                type: 'vendor',
            },
           
            nowDate: new Date().toISOString().slice(0, 10),
           
            vendor_list: [],
            type_list: [],
            valid: false,

            loading: false,

            invalid: true,
           
           
            
        }
    },

    mounted() {
    }
};
</script>
